import { useQuery, UseQueryResult } from "@tanstack/react-query";
import { enum_api_uri } from "../utils/enum";
import axiosInstance from "./axiosInstance";

export interface ConsoleOrderDetailRequest {
    category: string;
    serial_number: string;
}
export type DataListProps = {
    customer_info: string[];
    rider_info: string[];
    order_info: string[];
    delivery_info: string[];
    cost_info: string[];
};

export type ResponseData = DataListProps;

export const useGetConsoleQuickOrderDetail = (data: ConsoleOrderDetailRequest | null): UseQueryResult<ResponseData, Error> => {
    return useQuery({
        queryKey: ["useGetConsoleQuickOrderDetail", data],
        queryFn: async () => {
            if (!data) throw new Error("Invalid request data");
            let url = enum_api_uri.get_console_order_info.replace(":category", data.category).replace(":serial_number", data.serial_number);
            const response = await axiosInstance.get(url);
            return response.data.data;
        },
        enabled: !!data && !!data.serial_number,
    });
};
